module.exports = __webpack_public_path__ + "static/media/Inter-MediumItalic.a1b58862.woff";